import {useEffect, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';
import CustomCheckbox from '../../../../components/mazraeKit/customCheckbox';

interface IProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  filterAdType: string[];
  setFilterAdType: (types: string[]) => void;
}

const AdvertisementFilterBottomSheet = ({
  isOpen,
  setIsOpen,
  filterAdType,
  setFilterAdType,
}: IProps) => {
  // Local state only for the bottom sheet UI
  const [selectedFilters, setSelectedFilters] =
    useState<string[]>(filterAdType);

  // Sync local state with URL params when sheet opens
  useEffect(() => {
    if (isOpen) {
      setSelectedFilters(filterAdType);
    }
  }, [isOpen, filterAdType]);

  const toggleFilter = (filter: string) => {
    setSelectedFilters(prev =>
      prev.includes(filter)
        ? prev.filter(f => f !== filter)
        : [...prev, filter],
    );
  };

  const handleSubmit = () => {
    setFilterAdType(selectedFilters);
    setIsOpen(false);
  };

  return (
    <BottomSheet
      onDismiss={() => setIsOpen(false)}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 px-6 py-8">
        {/* Close Button */}
        <i
          className="absolute text-2xl text-gray-700 cursor-pointer icon-nameClose-remove top-7 left-7"
          onClick={() => setIsOpen(false)}
        />

        {/* Title */}
        <div className="flex flex-col items-center justify-center w-full gap-2">
          <p className="text-lg font-medium text-zinc-500">فیلترها</p>
        </div>

        {/* Filter Options */}
        <div className="flex flex-col gap-8">
          <CustomCheckbox
            name="available"
            title="فقط دارای موجودی"
            onChange={() => toggleFilter('available')}
            checked={selectedFilters.includes('available')}
            customClass="gap-1"
          />
          <CustomCheckbox
            name="has_price"
            title="فقط دارای قیمت ها"
            checked={selectedFilters.includes('has_price')}
            onChange={() => toggleFilter('has_price')}
            customClass="gap-1"
          />
        </div>

        <div className="flex items-center gap-2 pt-4">
          <Button className="flex-1" onClick={handleSubmit}>
            ثبت
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default AdvertisementFilterBottomSheet;
